import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=96c81558&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
import style0 from "./_contactus.css?vue&type=style&index=0&id=96c81558&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c81558",
  null
  
)

export default component.exports